"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapViewSettings = void 0;
var MapViewSettings = /** @class */ (function () {
    function MapViewSettings() {
        this.centre = null;
        this.zoom = 12;
        this.baselayers = new Map();
        this.overlays = new Map();
        this.accordions = {};
        this.opacity = 1.0;
        this.activePanel = null;
        this.baseLayerSliderPosition = null;
    }
    ;
    return MapViewSettings;
}());
exports.MapViewSettings = MapViewSettings;
//# sourceMappingURL=MapViewSettings.js.map